import { ReactComponent as Feed } from "../../../layout/sideNavigation/assets/icon_feed.svg";
import { ReactComponent as Friends } from "../../../layout/sideNavigation/assets/icon_friends.svg";
import { ReactComponent as Messages } from "../../../layout/sideNavigation/assets/icon_messages.svg";
import { ReactComponent as Zones } from "../../../layout/sideNavigation/assets/icon_zones.svg";
import { ReactComponent as Cup } from "../../../layout/sideNavigation/assets/icon_tournaments.svg";
import { ReactComponent as Gathers } from "../../../layout/sideNavigation/assets/icon_gathers.svg";
import { ReactComponent as News } from "../../../layout/sideNavigation/assets/icon_news.svg";
import { ReactComponent as Teams } from "../../../layout/sideNavigation/assets/icon_teams.svg";
import { ReactComponent as ChallengesLeft } from "../../../layout/sideNavigation/assets/challenges.svg";
import { ReactComponent as TrackerApp } from "../../../layout/sideNavigation/assets/flag.svg";
import { ReactComponent as SmartPhone } from "../../../../src/assets/icons/smartphone.svg";
import {
  brand,
  scheduleData,
} from "../../../utils/brandVariables/brandVariables";
import { siteRoutes } from "../../../routes/siteRoutesList";
// import { ReactComponent as LogitechLogoSmall } from "../assets/logitech/logitech-g-sm.svg";
import { ReactComponent as TCLLogo } from "../assets/tcl/tcl-logo.svg";
import { ReactComponent as PCSpecialistLogoSmall } from "../assets/pcspecialist/pcs-logo-main_small.svg";
import { ReactComponent as Elgiganten } from "../assets/elgiganten/elgiganten_sm_white.svg";
import { ReactComponent as JBL } from "../assets/jbl-quantum/quantum_logo.svg";
import { ReactComponent as TreasureHuntGift } from "../assets/gift.svg";
import { ReactComponent as BestgamerLogo } from "../assets/bestgamer/bg_logo_neg.svg";
import { ReactComponent as YouSee } from "../../../layout/sideNavigation/assets/partners/YouSee_brand_logo.svg";
import { ReactComponent as Partnerlogo } from "../assets/bestgamer/partnerlogo.svg";

export const BestGamer_siteRoutes = {
  "": [
    brand.hasFeature.treasure_hunt && {
      title: "TREASURE HUNT",
      link: siteRoutes["treasureHunt"],
      logo: YouSee,
    },
    // { title: "Friends", link: "friends", logo: Friends },
    // brand.hasFeature.messages && {
    //   title: "Messages",
    //   link: siteRoutes["messages"],
    //   logo: Messages,
    // },

    // brand.hasFeature.teams && {
    //   title: "strings.teams",
    //   link: siteRoutes["teams"],
    //   logo: Teams,
    // },
    // // { title: "Zones", link: "zones", logo: Zones },
    // brand.hasFeature.news && {
    //   title: "strings.news",
    //   link: siteRoutes["news"],
    //   logo: News,
    // },
  ],

  // edit any info in sidemenuLinks.tsx -> getBestGamerChallengeRoutes()
  challenges: [
    {
      title: "Subway surfers",
      link: siteRoutes["tcl"],
      logo: Partnerlogo,
      game: "subwaysurfers", // Must match name used in scss (theme-bestgamer.scss)
    },
    {
      title: "Fortnite",
      link: siteRoutes["jbl"],
      logo: Partnerlogo,
      game: "fortnite", // Must match name used in scss (theme-bestgamer.scss)
    },
    {
      title: "Fallguys",
      link: siteRoutes["pcspecialist"],
      logo: Partnerlogo,
      game: "fallguys", // Must match name used in scss (theme-bestgamer.scss)
    },
    {
      title: "Racing",
      link: siteRoutes["racing"],
      logo: Partnerlogo,
      game: "racing", // Must match name used in scss (theme-bestgamer.scss)
    },
  ],

  activities: [
    {
      title: "Activity",
      link: "/activity/monster",
      logo: Partnerlogo,
    },
    {
      title: "activity",
      link: "/activity/monster",
      logo: Partnerlogo,
      // logo: TreasureHuntGift,
    },
    // brand.hasFeature.challenges && {
    //   title: "strings.challenges",
    //   link: siteRoutes["challenges"],
    //   logo: ChallengesLeft,
    // },
    brand.hasFeature.getstarted && {
      title: "Getting started",
      link: "/tracker",
      logo: TrackerApp,
    },
    brand.hasFeature.gathers && {
      title: "strings.gathers",
      link: siteRoutes["gathers"],
      logo: Gathers,
    },
    brand.hasFeature.games && {
      title: "Event games",
      link: siteRoutes["gamesPage"],
      logo: SmartPhone,
    },
  ],

  // winners: [
  //   brand.hasFeature.winners && {
  //     title: "Winners",
  //     link: siteRoutes["winners"],
  //     logo: Cup,
  //   },
  // ],

  "  ": [
    {
      title: "About",
      link: siteRoutes["about"],
      logo: BestgamerLogo,
    },
  ],
};
